"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformTemplates = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var transformTemplates = (0, _utils.objFromListWith)((0, _ramda.prop)('id'));
exports.transformTemplates = transformTemplates;